import React, { useState, useEffect, useCallback } from 'react';
import cx from 'classnames';

import { ExternalFormWidgetContext } from '..';
import styles from '../style.module.scss';
import get from 'lodash/get';


let formCreated = {};

export const HubspotFormView = ({ form, uid }) => {
  const portalId = get(form.configuration, "portalId", null);
  const formId = get(form.configuration, "guid", null);
  const region = get(form, "region", null);
  const context = React.useContext(ExternalFormWidgetContext);
  const widgetContextRef = React.useRef(null);

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    widgetContextRef.current = context;
  }, [context]);

  useEffect(() => {
    appendScript();
  }, [])

  useEffect(() => {
    if (typeof window === "undefined") return;
    
    const onSuccess = async (event) => {
      if (event.detail.formId !== formId) return;
    
    try {
      const formInstance = window.HubSpotFormsV4.getFormFromEvent(event);
    
      const email = await formInstance.getFieldValue("0-1/email");
      const firstName = await formInstance.getFieldValue("0-1/firstname");
      const lastName = await formInstance.getFieldValue("0-1/lastname");
      const phone = await formInstance.getFieldValue("0-1/phone");
      const company = await formInstance.getFieldValue("0-1/company");
    
      const contactRequest = {
        email: email || null,
        firstName: firstName || null,
        lastName: lastName || null,
        workphone: phone || null,
        company: company || null,
        formSource: "hubspot",
      };
    
      handleFormSubmit(contactRequest);
      } catch (e) {
        console.error("Error getting V4 form values:", e);
      }
    };
    window.addEventListener("hs-form-event:on-submission:success", onSuccess);
    
    return () => {
      window.removeEventListener("hs-form-event:on-submission:success", onSuccess);
    };
    
  }, [formId]);
    
  useEffect(() => {
    if(!scriptLoaded){
      return;
    }
    
    if (window && window.hbspt) {
      if (formCreated[uid]) {
        return;
      }
      formCreated[uid] = true;

      window.hbspt.forms.create({
        region: region || "na1",
        portalId: portalId,
        formId: formId,
        target: `#contact_form_${uid}`,
        onFormSubmit: (form) => {

        },
        onFormSubmitted: (event, form) => {
          const email = form.submissionValues.email;
          const firstName = get(form.submissionValues, 'firstname') || null;
          const lastName = get(form.submissionValues, 'lastname') || null;
          const workphone = get(form.submissionValues, 'phone') || null;
          const company = get(form.submissionValues, 'company') || null;

          var contactRequest = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            workphone: workphone,
            company: company,
            formSource: 'hubspot',
          }

          handleFormSubmit(contactRequest)
        }
      });

      setTimeout(() => {
        formCreated[uid] = false;
      }, 300);
    }

  }, [scriptLoaded])

  const handleFormSubmit = useCallback((contactRequest) => {
    const widgetContext = widgetContextRef.current;
    if (widgetContext && widgetContext.onFormSubmit) {
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
    }
  }, [widgetContextRef]);

  const appendScript = () => {
    if (typeof window === "undefined") return;

    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/shell.js";
    script.key = "hubspot_form"
    script.type = "text/javascript"
    script.async = true;
    script.onload = () => {
      setScriptLoaded(true);
    };

    document.body.appendChild(script);
  }

  return (
    <div className={cx(styles.externalForm)}>
      <div id={`contact_form_${uid}`}></div>
    </div>
  )
}
